<!-- 开铺租赁合同及关铺终止合同盖章申请 -->
<template>
  <div class="pages">
    <div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
      <Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
      <Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
      <Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
      <Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
      <Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
      <Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
      <File v-if='item.Property.Control=="File"' :data-val="item"></File>
      <Table v-if='item.Property.Control=="Table"' :data-val='item'></Table>
      <Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
      <Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
      <Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
    </div>
    <Button class="submit-process" v-on:click='submit' size="large" type="primary"> 提交</Button>
  </div>
</template>

<script>
/**
 * Version 为Text文本组件
 */
import Digit from '../components/Number.vue'
import Contact from '../components/Contact.vue';
import Dates from '../components/Date.vue';
import Version from '../components/Text.vue';
import Money from '../components/Money.vue';
import Tips from '../components/Tips.vue';
import File from '../components/File.vue';
import Table from '../components/Table.vue';
import Selector from '../components/Selector.vue';
import Textarea from '../components/Textarea.vue';
import Choose from '../components/Choose.vue';
import {
  initWxConfig
} from "../api/jssdk.js";
import stringUtils from "../assets/js/stringUtil.js";
import wx from 'weixin-js-sdk'
import {
  getTemplateInfo,
  submitProcess,
  sendMessage,
  getFlowTemplate
} from '@/api/approval'
import {
  formatDate
} from '@/utils/date'

// Array.prototype.remove = function(val) {
// 	var index = this.indexOf(val);
// 	if (index > -1) {
// 		this.splice(index, 1);
// 	}
// };


var templateData = {
  TemplateContent: {
    Controls: []
  }
};
var logInfo = null;

var isSubmit = false;

export default {
  components: {
    Contact,
    Dates,
    Version,
    Money,
    Tips,
    File,
    Table,
    Digit,
    Selector,
    Textarea,
    Choose
  },
  data() {
    return {
      "templateData": templateData,
      loading: false,
      canApply: true,
      flowId: null
    }
  },
  created() {
    initWxConfig(this);
    this.logInfo = this.getLoginUserInfo();
    this.templateId = this.$route.query.templateId;
    this.spNo = this.$route.query.spNo;
    this.getTemplate();
    stringUtils.setAddIsShow(true);
  },
  mounted() { //页面挂载
    initWxConfig(this);
    // this.getTemplate();
    stringUtils.setAddIsShow(false);
  },

  methods: { //方法

    clickChoose(dataVal, name) {
      // this.$message.info(JSON.stringify(dataVal))
      var that = this;
      if (name == '代申请人') {
        window.wx.invoke("selectEnterpriseContact", {
          "fromDepartmentId": -1, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
          "mode": "single", // 必填，选择模式，single表示单选，multi表示多选
          "type": ["department", "user"], // 必填，选择限制类型，指定department、user中的一个或者多个
          "selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
          "selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
        }, function (res) {
          if (res.err_msg == "selectEnterpriseContact:ok") {
            if (typeof res.result == 'string') {
              res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
            }
            var user = res.result.userList[0];
            dataVal.Values.push([user.id, user.name]);
            dataVal.Value = user.name;
            that.getDept()
          }
        })
      }
    },
    getTemplate: async function () {
      let that = this;
      that.$http({
        url: that.$httpUrl.getTemplate + "?templateId=" + stringUtils.GetQueryString("templateId"),
        method: "get",
      }).then(async res => {
        if (res.data == null || res.data.ErrCode != 0) {
          that.$Message.error({ //error： 错误信息、success：成功、info：普通、warning：警告
            background: true,
            content: '模板获取错误'
          });
          return;
        }
        var controls = res.data.Body;
        that.templateData = res.data.Body;
        if (that.templateData == null) {
          alert("模板获取错误");
          return;
        }
        logInfo = JSON.parse(localStorage.getItem('logInfo'));
        if (logInfo == null) {
          logInfo = JSON.parse(stringUtils.getCookies("logInfo"));
        }
        for (var i = 0; i < that.templateData.TemplateContent.Controls.length; i++) {
          if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "申请部门") {
            that.templateData.TemplateContent.Controls[i].Disable = true;
            that.templateData.TemplateContent.Controls[i].IsShow = false;
          } else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "申请人") {
            that.templateData.TemplateContent.Controls[i].Value = `${logInfo.EmpName}(${logInfo.EmpNo})`;
            that.templateData.TemplateContent.Controls[i].Disable = true;
          } else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "逐级审批人员") {
            that.templateData.TemplateContent.Controls[i].IsShow = false;
          } else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "工号") {
            that.templateData.TemplateContent.Controls[i].Value = logInfo.EmpNo;
          } else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "入职时间") {
            that.templateData.TemplateContent.Controls[i].Value = logInfo.InCompanyDate;
          } else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "联系电话") {
            that.templateData.TemplateContent.Controls[i].Value = logInfo.Mobile;
          } else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "职位") {
            that.templateData.TemplateContent.Controls[i].Value = logInfo.PositionName;
          } else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "流程条件") {
            that.templateData.TemplateContent.Controls[i].Value = -1;
            var ii = i;
            that.$http({
              url: that.$httpUrl.GetRelation + "/" + logInfo.EmpNo + "/employee-relation",
              method: "get",
            }).then(res => {
              var nodes = res.data.Body[0].Nodes;
              if (logInfo.fullName.indexOf("商业地产部") > -1) {
                that.templateData.TemplateContent.Controls[ii].Value = 1;
                for (var k = 0; k < nodes.length; k++) {
                  if (nodes[k].Items != null) {
                    var items = nodes[k].Items;
                    for (var p = 0; p < items.length; p++) {
                      if (items[p].PositionName.indexOf("总监") > -1) {
                        that.templateData.TemplateContent.Controls[ii].Value = 1 + "." + (k + 1);
                      }
                    }
                  }
                }
              } else if (logInfo.fullName.indexOf("住宅部") > -1) {

                let quyu = 0; // 区域董事
                let daqu = 0; // 大区董事
                let zb = 0; // 张斌
                for (var k = 0; k < nodes.length; k++) {
                  if (nodes[k].Items != null) {
                    var items = nodes[k].Items;
                    that.templateData.TemplateContent.Controls[ii].Value = 2 + ".";

                    for (var p = 0; p < items.length; p++) {
                      if (items[p].PositionName.indexOf("区域董事") > -1) {
                        quyu = (k + 1);
                      } else if (items[p].PositionName.indexOf("大区董事") > -1) {
                        daqu = (k + 1);
                      } else if (items[p].EmpName == "张彬") {
                        zb = 1;
                      }
                    }

                  }
                }
                that.templateData.TemplateContent.Controls[ii].Value = that.templateData.TemplateContent.Controls[ii].Value + quyu + daqu + zb;
              } else if (logInfo.fullName.indexOf("二级市场") > -1 || logInfo.fullName.indexOf("代理") > -1) {
                for (var k = 0; k < nodes.length; k++) {
                  if (nodes[k].Items != null) {
                    var items = nodes[k].Items;
                    for (var p = 0; p < items.length; p++) {
                      if (items[p].PositionName.indexOf("营运部总经理") > -1 || items[p].PositionName.indexOf("拓展总监") > -1 || items[p].PositionName.indexOf("营运部副总经理") > -1) {
                        that.templateData.TemplateContent.Controls[ii].Value = 3 + "." + (k + 1);
                      }
                    }
                  }
                }
              } else if (logInfo.fullName.indexOf("房友圈") > -1) {
                for (var k = 0; k < nodes.length; k++) {
                  if (nodes[k].Items != null) {
                    var items = nodes[k].Items;
                    for (var p = 0; p < items.length; p++) {
                      if (items[p].PositionName.indexOf("区域总监") > -1) {
                        that.templateData.TemplateContent.Controls[ii].Value = 4 + "." + (k + 1);
                      }
                    }
                  }
                }
              }

            });
          } else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "申请时间") {
            let date = new Date();
            that.templateData.TemplateContent.Controls[i].Value = formatDate(date, "yyyy-MM-dd");
          } else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "端口费用承担部门") {
            that.templateData.TemplateContent.Controls[i].Value = logInfo.DeptName;
          }
          this.templateData = this.assignControl(controls, logInfo);
          this.templateData = await this.assignControlBySpNo(controls, this.spNo);
        }
        that.getDept()


      }, err => {
        console.log(err)
      });
    },
    getTextVal() {
      console.log(this.templateData)
    },

    reset() {
      var control1 = this.templateData.TemplateContent.Controls.filter(t => {
        return t.Property.Title[0].Text == "协议及函件类型（房友圈、汇瀚）"
      })[0];
      var control2 = this.templateData.TemplateContent.Controls.filter(t => {
        return t.Property.Title[0].Text == "协议及函件类型（住宅、工商）"
      })[0];
      var control3 = this.templateData.TemplateContent.Controls.filter(t => {
        return t.Property.Title[0].Text == "物业类型"
      })[0];
      var controls = [control1, control2, control3];
      controls.forEach((element, index) => {
        element.IsShow = false;
        element.Property.Require = 0;
      });
    },

    getSelectorVal(val, name, type, value) {
      console.log('********************');
      console.log(value)
      console.log(value.Value);

      var deptName = value.Config.Selector.Options.filter(t => {
        return t.Key == value.Value
      })[0].Value[0].Text;
      console.log(deptName)
      var control1 = this.templateData.TemplateContent.Controls.filter(t => {
        return t.Property.Title[0].Text == "协议及函件类型（房友圈、汇瀚）"
      })[0];
      var control2 = this.templateData.TemplateContent.Controls.filter(t => {
        return t.Property.Title[0].Text == "协议及函件类型（住宅、工商）"
      })[0];
      var control3 = this.templateData.TemplateContent.Controls.filter(t => {
        return t.Property.Title[0].Text == "物业类型"
      })[0];
      if (name == '申请部门') {
        this.reset();
        if (deptName == '住宅部' || deptName == '工商铺商业运营中心' || deptName == '商业地产部') {
          control2.IsShow = true;
          control2.Property.Require = 1;
        } else if (deptName == '房友圈' || deptName == '按揭金融服务中心') {
          console.log('*********************')
          console.log(control1)
          control1.IsShow = true;
          control1.Property.Require = 1;
          if (control1.Value != null) {
            var myValue = control1.Config.Selector.Options.filter(t => {
              return t.Key == control1.Value
            })[0].Value[0].Text;
            if (myValue == '合同类') {
              control3.IsShow = true;
              control3.Property.Require = 1;
            }
          }
        }
      } else if (name == '协议及函件类型（房友圈、汇瀚）') {
        this.reset();
        control1.IsShow = true;
        control1.Property.Require = 1;
        if (deptName == '合同类') {
          control3.IsShow = true;
          control3.Property.Require = 1;
        }
      }

      // var info={SummaryInfo:[]}
      // info.SummaryInfo=[];
      // info.SummaryInfo.push({"Disable":true});
      // SummaryList.push(info);

    },

    getDept() {
      var that = this;
      var control = this.templateData.TemplateContent.Controls.filter(t => {
        return t.Property.Title[0].Text == "申请部门"
      })[0];
      control.Value = null;
      var empNo = logInfo.EmpNo;
      var control4 = this.templateData.TemplateContent.Controls.filter(t => {
        return t.Property.Title[0].Text == "逐级审批人员"
      })[0];
      var control5 = this.templateData.TemplateContent.Controls.filter(t => {
        return t.Property.Title[0].Text == "代申请人"
      })[0];
      if (control5.Values != undefined && control5.Values.length > 0) {
        //alert(control5.Values[0])
        empNo = control5.Values[0][0]
      }
      control4.Values = []
      //control4.Values.push(['SC17003277', '唐崇敬'])
      //control4.Values.push(['SC18003883', '王明丽'])
      //control4.Value = "SC17003277"

      that.$http({
        url: that.$httpUrl.getuserinfo + "?code=" + empNo,
        method: "get",
      }).then(res => {
        var range = [];
        range[0] = {dept: "华西区/房友圈", value: "房友圈"};
        range[1] = {dept: "华西区/汇瀚", value: "汇瀚"};
        range[1] = {dept: "华西区/四川中原物业顾问有限公司/非营业部/职能中心/后勤支持部/后勤按揭部", value: "汇瀚"};
        range[2] = {dept: "华西区/代理", value: "代理"};
        range[3] = {dept: "华西区/四川中原物业顾问有限公司/营业部/住宅部", value: "住宅部"};
        range[4] = {dept: "华西区/四川中原物业顾问有限公司/营业部/工商铺商业运营中心", value: "工商铺商业运营中心"};
        range[5] = {dept: "华西区/四川中原物业顾问有限公司/营业部/二级市场营运中心", value: "二级市场营运中心"};
        range[6] = {dept: "华西区/藤云", value: "房友圈"};
        range[7] = {dept: "华西区/四川中原物业顾问有限公司/营业部/商业地产部", value: "工商铺商业运营中心"};
        var fullName = res.data.Body.EmployeeInfo.fullName;

        var gets = range.filter(f => fullName.indexOf(f.dept) >= 0);
        this.canApply = true
        if (gets == null || gets.length == 0) {
          this.canApply = false
          return;
        }

        var getDept = gets[0].value;
        if(fullName === "华西区/代理/非营业部/职能中心/交易管理部"){
          getDept = "住宅部"
        }
        console.log(getDept);
        console.log(fullName)
        console.log(range)

        var control = this.templateData.TemplateContent.Controls.filter(t => {
          return t.Property.Title[0].Text == "申请部门"
        })[0];
        var obj = control.Config.Selector.Options.filter(t => {
          return t.Value[0].Text == getDept
        })[0];
        control.Value = obj.Key
        var deptName = gets[0].value

        var control1 = this.templateData.TemplateContent.Controls.filter(t => {
          return t.Property.Title[0].Text == "协议及函件类型（房友圈、汇瀚）"
        })[0];
        var control2 = this.templateData.TemplateContent.Controls.filter(t => {
          return t.Property.Title[0].Text == "协议及函件类型（住宅、工商）"
        })[0];
        var control3 = this.templateData.TemplateContent.Controls.filter(t => {
          return t.Property.Title[0].Text == "物业类型"
        })[0];

        this.reset();
        if (deptName == '住宅部' || deptName == '工商铺商业运营中心' || deptName == '商业地产部') {
          control2.IsShow = true;
          control2.Property.Require = 1;
        } else if (deptName == '房友圈' || deptName == '按揭金融服务中心') {
          control1.IsShow = true;
          control1.Property.Require = 1;
        }


        if (gets[0].value == "住宅部") {
          //逐级审批至8级
          that.$http({
            url: that.$httpUrl.GetRelation + "/" + empNo + "/employee-relation",
            method: "get",
          }).then(res => {
            var nodes = res.data.Body[0].Nodes;
            console.log(nodes)
            //console.log(nodes.filter(f => f.Items != null && f.Items.length > 0));
            var empnos = nodes.filter(f => f.Items != null && f.Items.length > 0 && f.Items[0].JobLevel <= 8).map(f => [f.Items[0].EmpNo, f.Items[0].EmpName]);
            console.log(empnos)
            var eps = [];
            empnos.forEach(f => {
              if (f[0] != empNo) {
                eps.push(f);
              }
            });

            var length = eps.length;
            if (length == 0) {
              eps.push(["SC24000029", "钟志斌"]);
            }


            eps.forEach(element => {
              control4.Values.push(element)
            });
          })
        } else if (gets[0].value == "工商铺商业运营中心" || gets[0].value == "商业地产部") {
          //逐级审批至前一级
          that.$http({
            url: that.$httpUrl.GetRelation + "/" + empNo + "/employee-relation",
            method: "get",
          }).then(res => {
            var nodes = res.data.Body[0].Nodes;
            console.log("deede")
            //console.log(nodes.filter(f => f.Items != null && f.Items.length > 0));
            var empnos = nodes.filter(f => f.Items != null && f.Items.length > 0 && f.Items[0].JobLevel <= 10).slice(0, 1).map(f => [f.Items[0].EmpNo, f.Items[0].EmpName]);
            empnos = empnos.filter(e => e[0][0] !== "SC24000029")
            var eps = [];
            empnos.forEach(f => {
              if (f[0] != empNo) {
                eps.push(f);
              }
            });
            eps.forEach(element => {
              control4.Values.push(element)
            });
          })
        } else if (gets[0].value == "二级市场营运中心" || gets[0].value == "代理") {
          //逐级审批至前两级
          that.$http({
            url: that.$httpUrl.GetRelation + "/" + empNo + "/employee-relation",
            method: "get",
          }).then(res => {
            var nodes = res.data.Body[0].Nodes;
            console.log(nodes)
            //console.log(nodes.filter(f => f.Items != null && f.Items.length > 0));
            var empnos = nodes.filter(f => f.Items != null && f.Items.length > 0 && f.Items[0].JobLevel <= 8).map(f => [f.Items[0].EmpNo, f.Items[0].EmpName]);
            var eps = [];
            empnos.forEach(f => {
              if (f[0] != empNo) {
                eps.push(f);
              }
            });

            console.log(empnos)
            var length = eps.filter(f => f[0] === "SC23000441").length;
            if (length == 0) {
              eps.push(["SC23000441", "陈相云"]);
            }
            eps.forEach(element => {
              control4.Values.push(element)
            });
            console.log("eps")
            console.log(eps)
          })
        } else if (gets[0].value == "房友圈") {
          //逐级审批至8级下最后一位审批人
          that.$http({
            url: that.$httpUrl.GetRelation + "/" + empNo + "/employee-relation",
            method: "get",
          }).then(res => {
            var nodes = res.data.Body[0].Nodes;
            console.log(nodes)
            //console.log(nodes.filter(f => f.Items != null && f.Items.length > 0));
            var empnos = nodes.filter(f => f.Items != null && f.Items.length > 0 && f.Items[0].JobLevel <= 7).slice(-1).map(f => [f.Items[0].EmpNo, f.Items[0].EmpName]);
            console.log(empnos)
            var eps = [];
            empnos.forEach(f => {
              if (f[0] != empNo) {
                eps.push(f);
              }
            });
            var length = eps.length;
            if (length == 0) {
              eps.push(["SC24000029", "钟志斌"]);
            }
            console.log(eps)
            eps.forEach(element => {
              control4.Values.push(element)
            });
          })
        } else if (gets[0].value == "汇瀚") {
          //逐级审批至7级
          that.$http({
            url: that.$httpUrl.GetRelation + "/" + empNo + "/employee-relation",
            method: "get",
          }).then(res => {
            var nodes = res.data.Body[0].Nodes;
            console.log(nodes)
            //console.log(nodes.filter(f => f.Items != null && f.Items.length > 0));
            var empnos = nodes.filter(f => f.Items != null && f.Items.length > 0 && f.Items[0].JobLevel <= 7).map(f => [f.Items[0].EmpNo, f.Items[0].EmpName]);
            console.log(empnos)
            var eps = [];
            empnos.forEach(f => {
              if (f[0] != empNo) {
                eps.push(f);
              }
            });

            var length = eps.filter(f => f[0] == "SC04110010").length;
            if (length == 0) {
              eps.push(["SC04110010", "杨小玉"]);
            }

            // if(eps.length == 0 || eps.includes("SC04110010") == false){
            // 	//杨小玉
            // 	eps.push("SC04110010");
            // }
            eps.forEach(element => {
              control4.Values.push(element)
            });
          })
        }

      })
    },

    submit() {
      let that = this;
      if (this.canApply == false) {
        this.Message({
          message: '申请人或代申请人没有申请权限',
          type: 'warning',
          duration: 1000
        });
        return
      }
      if (this.loading) {
        this.Message({
          message: '正在提交',
          type: 'warning',
          duration: 1000
        });
        return
      }
      that.loading = true
      //数据校验
      if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
        that.loading = false
        return;
      }
      if (isSubmit) {
        this.Message({
          message: '已提交',
          type: 'warning',
          duration: 1000
        });
        that.loading = false
        return
      }

      var SummaryList = [];
      var info = {SummaryInfo: []}
      info.SummaryInfo = [];

      // var control1=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "合同名称"})[0]
      // if(control1.Value!=null&&control1.Value.length>0){
      // 	var info={SummaryInfo:[]}
      // 	info.SummaryInfo=[];
      // 	info.SummaryInfo.push({"Text":"内容："+control1.Value,"Lang":"zh_CN"});
      // 	SummaryList.push(info);
      // }

      // var control2=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请部门："})[0]
      // var info={SummaryInfo:[]}
      // info.SummaryInfo=[];
      // info.SummaryInfo.push({"Text":"申请部门："+control2.Value,"Lang":"zh_CN"});
      // SummaryList.push(info);


      var data = new Date();
      var month = data.getMonth() < 9 ? "0" + (data.getMonth() + 1) : data.getMonth() + 1;
      var date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
      var dateTime = data.getFullYear() + "-" + month + "-" + date;
      var info = {SummaryInfo: []}
      info.SummaryInfo = [];
      info.SummaryInfo.push({"Text": "申请时间：" + dateTime, "Lang": "zh_CN"});
      SummaryList.push(info);
      this.templateData.SummaryList = SummaryList;

      that.$http.post(that.$httpUrl.startProcess + "?temId=" + stringUtils.GetQueryString("templateId") + "&empNo=" +
          logInfo.EmpNo + "&spNo=" + stringUtils.GetQueryString("spNo"), that.templateData).then(res => {
        isSubmit = false;
        console.log(res);
        if (res.data.ErrCode == 0) {
          that.$message.info("申请成功");
          that.$router.push("/index");
        } else {
          that.$message.error(res.data.ErrMsg);
        }
      }, err => {
        console.log(err)
      });
    }
  }
}
</script>

<style scoped lang="less">
.pages {
  padding-bottom: 14px;
}
</style>
